import { render, staticRenderFns } from "./submitRes.vue?vue&type=template&id=43f9b456&scoped=true"
import script from "./submitRes.vue?vue&type=script&lang=js"
export * from "./submitRes.vue?vue&type=script&lang=js"
import style0 from "./submitRes.vue?vue&type=style&index=0&id=43f9b456&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f9b456",
  null
  
)

export default component.exports